import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */
export var JQLParseError = /*#__PURE__*/function (_Error) {
  _inherits(JQLParseError, _Error);

  var _super = _createSuper(JQLParseError);

  /**
   * The original JS error that was thrown trying to parse JQL.
   */

  /**
   * The error message. We use a separate property here so consumers can perform shallow comparison of error objects.
   */
  function JQLParseError(message, cause) {
    var _this;

    _classCallCheck(this, JQLParseError);

    _this = _super.call(this, message);

    _defineProperty(_assertThisInitialized(_this), "cause", void 0);

    _defineProperty(_assertThisInitialized(_this), "description", void 0);

    _this.name = 'JQLParseError';
    _this.cause = cause;
    _this.description = message;
    return _this;
  }

  return JQLParseError;
}( /*#__PURE__*/_wrapNativeSuper(Error));